import { TOGGLE_SIDE_NAVIGATION } from '../../mutation-types';

export default {
    [TOGGLE_SIDE_NAVIGATION](state, { isOpen }) {
        state.isOpen = isOpen;
    },
};
